<template>
    <section class="flex-column">
        <!-- TYPE -->
        <el-form-item prop="type" :label="$t.__('common.labels.type')" class="flex-column">
            <el-select v-model="type" class="wp-5">
                <el-option
                    v-for="option in types"
                    :key="option.label"
                    :value="option.value"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>
        <!-- CIVILITY -->
        <el-form-item prop="civility" :label="$t.__('common.labels.civility')" class="flex-column">
            <el-select v-model="civility" class="wp-5">
                <el-option
                    v-for="option in civilities"
                    :key="option.label"
                    :value="option.value"
                    :label="option.label"
                />
            </el-select>
        </el-form-item>
        <!-- NAME -->
        <el-form-item prop="name" :label="$t.__('common.labels.name')">
            <el-input name="lastname" ref="name" autocomplete="off" v-model="name"></el-input>
        </el-form-item>
        <!-- FIRSTNAME -->
        <el-form-item prop="firstName" :label="$t.__('common.labels.first_name')">
            <el-input name="firstname" autocomplete="off" v-model="firstName"></el-input>
        </el-form-item>
        <!-- BIRTHDATE -->
        <el-form-item prop="birthDate" :label="$t.__('common.labels.birthdate')">
            <el-date-picker
                v-model="birthDate"
                type="date"
                default-value="01-01-1990"
                :format="datePickerFormat"
                :placeholder="datePickerFormat.toUpperCase()"
            >
            </el-date-picker>
        </el-form-item>
        <!-- EMAIL -->
        <el-form-item prop="email" :label="$t.__('common.labels.email')">
            <el-input type="email" autocomplete="off" v-model="email"></el-input>
        </el-form-item>
        <!-- PHONE + MOBILE + FAX -->
        <contact-number :currentStore="storeModule" :error="error" />
    </section>
</template>

<script>
import ContactNumber from 'vcomponents/thirds/thirdscomponents/FormFieldsNumberPhone.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'FormFieldsIndividualsDetails',
    props: {
        storeModule: {
            type: String,
            default: () => 'store-module-name',
        },
        error: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    components: {
        ContactNumber,
    },
    computed: {
        // TYPE
        type: {
            get() {
                return this.$store.getters[`${this.storeModule}/getType`];
            },
            set(newValue) {
                this.$store.commit(`${this.storeModule}/setIndividualType`, newValue);
                this.$emit('change-type', newValue);
            },
        },
        types() {
            return this.$store.getters[`${this.storeModule}/getTypes`];
        },
        // CIVILITY
        civility: {
            get() {
                return this.$store.getters[`${this.storeModule}/getCivility`];
            },
            set(newValue) {
                this.$store.commit(`${this.storeModule}/setIndividualCivility`, newValue);
            },
        },
        civilities() {
            return this.$store.state[this.storeModule].civilities;
        },
        // NAME
        name: {
            get() {
                return this.$store.getters[`${this.storeModule}/getName`];
            },
            set(newValue) {
                this.$store.commit(`${this.storeModule}/setIndividualName`, newValue);
            },
        },
        // FIRSTNAME
        firstName: {
            get() {
                return this.$store.getters[`${this.storeModule}/getFirstName`];
            },
            set(newValue) {
                this.$store.commit(`${this.storeModule}/setIndividualFirstName`, newValue);
            },
        },
        // BIRTHDATE
        ...mapGetters('corp', ['datePickerFormat']),
        birthDate: {
            get() {
                return this.$store.getters[`${this.storeModule}/getBirthDate`];
            },
            set(newValue) {
                this.$store.commit(`${this.storeModule}/setIndividualbirthDate`, newValue);
            },
        },
        // EMAIL
        email: {
            get() {
                return this.$store.getters[`${this.storeModule}/getEmail`];
            },
            set(newValue) {
                this.$store.commit(`${this.storeModule}/setIndividualEmail`, newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped></style>
